.bar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: var(--space-4);
  height: 52px;
  padding-inline: max(var(--space-3), env(safe-area-inset-left)) max(var(--space-3), env(safe-area-inset-right));
  background: var(--bg);
  border-bottom: var(--hairline) solid var(--separator);
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-width: 0;
  color: var(--ink);
  font: var(--text-headline);
  text-decoration: none;
}

.brand > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.places {
  display: flex;
  gap: var(--space-3);
  font: var(--text-subhead);
}

.places a,
.out {
  color: var(--label-2);
  text-decoration: none;
}

.places a[aria-current="page"] {
  color: var(--label);
}

.me {
  margin-inline-start: auto;
  color: var(--label-3);
  font: var(--text-footnote);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.out {
  font: var(--text-subhead);
}

.main {
  display: block;
}

.waiting {
  min-height: 100vh;
}

.blocks {
  margin-top: var(--space-8);
}

.need {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.need a,
.clientName a,
.decided a {
  color: var(--label);
}

.meta,
.small {
  color: var(--label-3);
  font: var(--text-footnote);
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: var(--space-4);
}

.client,
.member {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.client {
  padding-top: var(--space-3);
  border-top: var(--hairline) solid var(--separator);
}

.clientName {
  font: var(--text-headline);
}

.headline {
  font: var(--text-callout);
  text-wrap: pretty;
}

.needs {
  color: var(--warn-text);
  font: var(--text-subhead);
}

.detail {
  color: var(--label-2);
  font: var(--text-callout);
  text-wrap: pretty;
}

.alert {
  font: var(--text-footnote);
  text-wrap: pretty;
}

.decided {
  composes: plain-list from global;
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin-block: 1em;
  font: var(--text-footnote);
}

.late {
  color: var(--warn-text);
  font: var(--text-footnote);
}

.open {
  align-self: flex-start;
  margin-top: auto;
  color: var(--other-text);
  font: var(--text-subhead);
}

.holds {
  composes: plain-list from global;
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-block: 1em;
}

.hold {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  font: var(--text-callout);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.problem {
  color: var(--neg-text);
  font: var(--text-callout);
}

@media (max-width: 560px) {
  .me {
    display: none;
  }

  .places {
    margin-inline-start: auto;
  }
}
